import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const SplitAc = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M12.667 4.63a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z" />
      <path
        d="M2 2.297a1 1 0 0 0-1 1v3.667a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3.297a1 1 0 0 0-1-1H2Zm-1.666 1c0-.92.746-1.666 1.667-1.666h12c.92 0 1.666.746 1.666 1.666v3.667c0 .92-.746 1.667-1.667 1.667H2c-.92 0-1.666-.747-1.666-1.667V3.297Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M2.668 6.63c0-.184.15-.333.333-.333h10a.333.333 0 1 1 0 .667h-10a.333.333 0 0 1-.333-.334ZM8.001 10.63c.184 0 .334.15.334.334v4.333a.333.333 0 1 1-.667 0v-4.333c0-.184.15-.333.333-.333ZM4.651 10.631c.184-.009.34.133.35.317a6.129 6.129 0 0 1-.705 3.172l-.001.002a5.94 5.94 0 0 1-1.06 1.413.333.333 0 0 1-.468-.475c.374-.369.691-.79.94-1.253.46-.869.677-1.845.628-2.826a.333.333 0 0 1 .316-.35ZM11.351 10.631c.184.01.326.166.316.35a5.463 5.463 0 0 0 .628 2.826c.25.462.566.884.94 1.253a.333.333 0 0 1-.468.475 5.94 5.94 0 0 1-1.06-1.413v-.002a6.129 6.129 0 0 1-.705-3.172.333.333 0 0 1 .35-.317Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

SplitAc.category = 'product-category';

SplitAc.displayName = 'SplitAc';
